import React, { useEffect, useState } from 'react'
import Carrier from '../Carrier/Carrier'
import PoweredByFooter from '../Footer/PoweredByFooter'
import CarrierNavBar from '../Carrier/Components/CarrierNavBar'
import ExpiredCarrierView from './ExpiredCarrierView'
import isShipmentExpired from '../../utils/helpers/isShipmentExpired'
import { Fade } from 'react-awesome-reveal'
// BreakoutCarrier exists to handle Consolidations

const BreakoutCarrier = (props) => {

    let breakoutCarrierDebug = false
    const driverCode = props.match.params.driverCode
    // const pickupOrDelivery = props.match.params.type

    const searchParams = new URLSearchParams(props.location.search)
    const showHeader = !searchParams.get('showHeader') || searchParams.get('showHeader') === 'true' ? true : false
    const showFooter = !searchParams.get('showFooter') || searchParams.get('showFooter') === 'true' ? true : false
    const [isConsolidation, setIsConsolidation] = useState(false)
    const [consolidationDriverCodes, setConsolidationDriverCodes] = useState([])
    const [stopsDriverCodesEnhanced, setStopsDriverCodesEnhanced] = useState([])
    const [breakoutCarrierStatus, setBreakoutCarrierStatus] = useState('loading')
    const [expiredReason, setExpiredReason] = useState(null)
    const [client, setClient] = useState("")
    const [parentShipment, setParentShipment] = useState(null)

    // Known route names that can end up as the driverCode param when a user
    // navigates to /carrier/<routeName>/ by mistake — fail immediately without
    // making an API call.
    const RESERVED_PATHS = ['quickschedule']

    useEffect(() => {
        if (!driverCode || RESERVED_PATHS.includes(driverCode.toLowerCase())) {
            setBreakoutCarrierStatus('noDriverCode')
            return
        }
        checkIfConsolidation(driverCode)
    }, [driverCode]) // eslint-disable-line react-hooks/exhaustive-deps

    const checkIfConsolidation = async (driverCode) => {
        try {
            let url = 'https://api.shippersedge.com/schedule/isConsolidation/' + driverCode
            let myHeaders = new Headers();
            myHeaders.append("x-api-key", "vdhy8wwjUJrwhxFpfuECTiAW");

            var requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow",
            };

            let request = new Request(url, requestOptions);

            let checkIfConsolidationResponse = await fetch(request)
            if (!checkIfConsolidationResponse.ok) {
                setBreakoutCarrierStatus('error')
                return
            }
            let checkIfConsolidationResponseJSON = await checkIfConsolidationResponse.json()
            // Parent Shipment Is the full V4 object
            const shipV4 = checkIfConsolidationResponseJSON?.shipV4
            setParentShipment(shipV4)
            const expiryCheck = isShipmentExpired(shipV4)
            if (expiryCheck.expired) {
                setExpiredReason(expiryCheck.reason)
                setBreakoutCarrierStatus('expired')
                return
            }
            if (checkIfConsolidationResponseJSON.isConsolidation) {
                setIsConsolidation(true)
                setConsolidationDriverCodes(checkIfConsolidationResponseJSON.stopsDriverCodes)
                if (checkIfConsolidationResponseJSON?.stopsDriverCodesEnhanced) {
                    setStopsDriverCodesEnhanced(checkIfConsolidationResponseJSON.stopsDriverCodesEnhanced)
                }
                setClient(checkIfConsolidationResponseJSON.client)
                setBreakoutCarrierStatus('consolidation')
            } else {
                setClient(checkIfConsolidationResponseJSON.client)
                setBreakoutCarrierStatus('notConsolidation')
            }
        } catch (e) {
            console.error('checkIfConsolidation error', e)
            setBreakoutCarrierStatus('error')
        }
    }

    const handleReload = () => {
        window.location.reload(true);
    };

    if (breakoutCarrierStatus === 'loading') {
        return (
            <div className="container">
                <div className="row justify-content-center mt-5">
                    <div className="col-12 col-md-6 text-center">
                        <div className="mb-4">
                            <img src="https://scheduler.shippersedge.com/shippersedge-logo.png" alt="logo" style={{ maxWidth: '300px' }} className="img-fluid" />
                            <span className="TitleText mt-2 d-block">Dock Scheduler</span>
                        </div>
                        <img src="https://scheduler.shippersedge.com/loading.gif" alt="loading icon" height="200px" title="Loading" />
                        <div>Loading Shipment...</div>
                    </div>
                </div>
            </div>
        )
    }

    if (breakoutCarrierStatus === 'noDriverCode') {
        return <div>No Driver Code</div>
    }

    if (breakoutCarrierStatus === 'error') {
        return <div>Error <button className="btn btn-primary" onClick={handleReload}>Click to reload the page.</button></div>
    }

    if (breakoutCarrierStatus === 'expired') {
        return <ExpiredCarrierView shipment={parentShipment} isConsolidation={!!(parentShipment?.stops?.length)} reason={expiredReason} />
    }

    if (isConsolidation && stopsDriverCodesEnhanced.length) {
        return (
            <>
                {breakoutCarrierDebug ? <div>Consolidation Here</div> : null}
                {showHeader ? <CarrierNavBar client={client} /> : null}
                {stopsDriverCodesEnhanced.length > 1 ?
                    <div className="d-flex justify-content-center">
                        <div className="alert alert-success border-dark" role="alert">
                            There are {stopsDriverCodesEnhanced.length} stops that require an appointment on the Dock Scheduler.<br />  Scroll down to see all stops.
                        </div>
                    </div> : null}

                {stopsDriverCodesEnhanced.map((enhancedDriverCodeOBJ, index) => {
                    index++
                    return (
                        <React.Fragment key={enhancedDriverCodeOBJ.stopNumber}>
                            <Fade>
                                < div className='mt-3' >
                                    {breakoutCarrierDebug ? <div>{enhancedDriverCodeOBJ.driverCode}</div > : null}
                                    <Carrier driverCode={enhancedDriverCodeOBJ.driverCode} isConsolidation={true} stopNumber={enhancedDriverCodeOBJ.stopNumber} enhancedDriverCodeOBJ={enhancedDriverCodeOBJ} parentShipment={parentShipment} />
                                </div >
                            </Fade>
                        </React.Fragment>
                    )
                })}
                {showFooter ? <PoweredByFooter isConsolidation={isConsolidation} /> : null}
            </>
        )

    }


    if (isConsolidation && consolidationDriverCodes.length) {
        return (
            <>
                {breakoutCarrierDebug ? <div>Consolidation</div> : null}
                {showHeader ? <CarrierNavBar client={client} /> : null}
                {consolidationDriverCodes.length > 1 ?
                    <div className="d-flex justify-content-center">
                        <div className="alert alert-success border-dark" role="alert">
                            There are {consolidationDriverCodes.length} stops that require an appointment on the Dock Scheduler.<br />  Scroll down to see all stops.
                        </div>
                    </div> : null}

                {consolidationDriverCodes.map((driverCode, index) => {
                    index++
                    return (
                        <React.Fragment key={index}>
                            <Fade>
                                < div className='mt-3' >
                                    {breakoutCarrierDebug ? <div>{driverCode}</div > : null}
                                    <Carrier driverCode={driverCode} isConsolidation={true} stopNumber={index} parentShipment={parentShipment} />
                                </div >
                            </Fade>
                        </React.Fragment>
                    )
                })}
                {showFooter ? <PoweredByFooter isConsolidation={isConsolidation} /> : null}
            </>
        )

    }

    if (!isConsolidation) {
        return (
            <>

                {showHeader ? <CarrierNavBar client={client} /> : null}
                {breakoutCarrierDebug ? <div>Not consolidation</div> : null}
                <Carrier driverCode={driverCode} isConsolidation={false} parentShipment={parentShipment} />
                {showFooter ? <PoweredByFooter isConsolidation={isConsolidation} /> : null}

            </>
        )
    }


    return (
        <div className="container">
            <div className="alert alert-warning mt-3" role="alert">
                <h3>Breakout Carrier Error</h3>
                <p>There was an error processing the breakout carrier request.</p>
                <p>Please contact support.</p>
            </div>
        </div>

    )
}

export default BreakoutCarrier